import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useIndoorviewStore = defineStore('indoorview', () => {
  // States
  const isIndoorviewCropActive = ref<boolean>(false)
  const isIndoorviewMeasurementActive = ref<boolean>(false)

  // Getters

  // Actions
  function setIsIndoorviewCropActive(isActive: boolean) {
    isIndoorviewCropActive.value = isActive
  }
  function setIsIndoorviewMeasurementActive(isActive: boolean) {
    isIndoorviewMeasurementActive.value = isActive
  }
  return {
    isIndoorviewCropActive,
    isIndoorviewMeasurementActive,
    setIsIndoorviewCropActive,
    setIsIndoorviewMeasurementActive
  }
})
